import { PlayerTeamListModel } from "../report/meta-data/PlayerMetaDataModel";
import { StratusStatsColumnValuesModel } from "./StratusStatsColumnValuesModel";

export class StratusStatsCardPlayerTemplateModel {
    startingNumber: number;
    playerFirstName: string;
    playerLastName: string;
    playerName: string;
    columnValues: StratusStatsColumnValuesModel[];
    playerId: string;
    metricId: string;
    value: number;
    totalValue: number;
    suffix: string;
    group: string;
    teams: PlayerTeamListModel[]

    get displayValue() {
        if (this.value >= 0 && this.totalValue >= 0 && this.totalValue != null)
            return `${this.value}/${this.totalValue}`;
        else
            return `${this.value}${this.suffix}`;
    }

    get topOrderValue() {
        if (this.value >= 0 && this.totalValue >= 0 && this.totalValue != null)
            return this.totalValue;
        else
            return this.value;
    }

    constructor(startingNumber: number, playerName: string, firstName: string, lastName: string, playerId: string, group: string, teams: PlayerTeamListModel[]) {
        this.startingNumber = startingNumber;
        this.playerName = playerName;
        this.playerFirstName = firstName;
        this.playerLastName = lastName;
        this.columnValues = [];
        this.playerId = playerId;
        this.group = group;
        this.teams = teams;
        this.suffix = '';
        this.value = null;
        this.totalValue = null;
    }
}